var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82291 11.7885C8.28361 11.9233 8.76036 11.9938 9.23992 11.9979C10.0194 12.0266 10.7821 11.7646 11.383 11.2615C11.9187 10.7849 12.122 10.1588 11.928 9.54582C11.806 9.1384 11.2315 8.93655 10.9008 8.85245C9.69993 8.54782 9.4376 8.47867 8.83902 8.30299C8.46952 8.19646 8.24598 8.54034 8.08525 8.79265C8.00027 8.92721 7.82107 9.20755 7.73978 9.18512C6.6313 8.89357 5.27341 7.10687 4.84665 6.35182C5.03516 6.13965 5.25221 5.95532 5.49141 5.80423C5.70387 5.65284 5.88677 5.52202 5.82211 5.26037C5.75745 4.99872 5.21799 2.83076 5.19213 2.71676C4.97043 1.89816 4.60094 1.93741 3.90814 2.08132L3.75295 2.11309C3.03244 2.26074 2.45973 2.82515 2.18076 3.6643C1.77986 4.86602 1.94428 6.99287 3.72339 9.03374C4.91501 10.3999 6.37081 11.3811 7.82291 11.7885Z",
    fill: "#5656FC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.663de4db.svg";
export { ForwardRef as ReactComponent };